/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  OnDestroy,
  OnInit,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import {
  NB_AUTH_OPTIONS,
  NbAuthSocialLink,
  NbAuthService,
  NbAuthResult,
} from "@nebular/auth";
import { getDeepFromObject } from "../../helpers";
import { NbThemeService } from "@nebular/theme";
import { EMAIL_PATTERN } from "../constants";
import { UserService } from "../../../@core/services/user.service";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { environment } from "../../../../environments/environment";

@Component({
  selector: "ngx-login",
  templateUrl: "./login.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NgxLoginComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  allowRegister = environment.allowRegister;

  minLength: number = this.getConfigValue(
    "forms.validation.password.minLength"
  );
  maxLength: number = this.getConfigValue(
    "forms.validation.password.maxLength"
  );
  redirectDelay: number = this.getConfigValue("forms.login.redirectDelay");
  showMessages: any = this.getConfigValue("forms.login.showMessages");
  strategy: string = this.getConfigValue("forms.login.strategy");
  socialLinks: NbAuthSocialLink[] = this.getConfigValue(
    "forms.login.socialLinks"
  );
  rememberMe = this.getConfigValue("forms.login.rememberMe");
  isEmailRequired: boolean = this.getConfigValue(
    "forms.validation.email.required"
  );
  isPasswordRequired: boolean = this.getConfigValue(
    "forms.validation.password.required"
  );

  errors: string[] = [];
  messages: string[] = [];
  user: any = {};
  submitted: boolean = false;
  loginForm: FormGroup;
  alive: boolean = true;
  returnUrl: string;

  get email() {
    return this.loginForm.get("email");
  }
  get password() {
    return this.loginForm.get("password");
  }

  constructor(
    protected service: NbAuthService,
    @Inject(NB_AUTH_OPTIONS) protected options = {},
    protected cd: ChangeDetectorRef,
    protected themeService: NbThemeService,
    private fb: FormBuilder,
    protected router: Router,
    private activatedRoute: ActivatedRoute,
    public userService: UserService
  ) {
    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((userLogin) => {
        if (userLogin) {
          this.router.navigate(["home"]);
        }
      });
  }

  ngOnInit(): void {
    const emailValidators = [Validators.pattern(EMAIL_PATTERN)];
    this.isEmailRequired && emailValidators.push(Validators.required);

    const passwordValidators = [
      Validators.minLength(this.minLength),
      Validators.maxLength(this.maxLength),
    ];
    this.isPasswordRequired && passwordValidators.push(Validators.required);

    this.loginForm = this.fb.group({
      email: this.fb.control("", [...emailValidators]),
      password: this.fb.control("", [...passwordValidators]),
      rememberMe: this.fb.control(false),
    });

    this.returnUrl =
      this.activatedRoute.snapshot.queryParams.returnUrl || "/home";
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  login(): void {
    this.user = this.loginForm.value;
    this.errors = [];
    this.messages = [];
    this.submitted = true;

    //method 1: call NbAuthService
    // this.service
    //   .authenticate(this.strategy, this.user)
    //   .subscribe((result: NbAuthResult) => {
    //     this.submitted = false;

    //     if (result.isSuccess()) {
    //       this.messages = result.getMessages();
    //       window.location.href = "/";

    //       return this.router.navigateByUrl(this.returnUrl);
    //     } else {
    //       this.errors = result.getErrors();
    //     }

    //     const redirect = result.getRedirect();
    //     if (redirect) {
    //       setTimeout(() => {
    //         return this.router.navigateByUrl(this.returnUrl);
    //       }, this.redirectDelay);
    //     }

    //     this.cd.detectChanges();
    //   });

    //method 2: call userService
    let email = this.loginForm.value.email;
    if (email) {
      email = email.toLowerCase();
    }
    let password = this.loginForm.value.password;
    console.log("UserService/signIn/email:", email);
    console.log("UserService/signIn/password:", password);

    this.userService
      .signIn(email, password)
      .then((result) => {
        console.log("UserService/signIn:", result);
        window.location.href = "/";
      })
      .catch((error) => {
        console.log("UserService/signIn/error:", error);

        this.submitted = false;
        this.showMessages.error = true;
        this.errors.push(error.message);
        this.cd.detectChanges();
      });
  }

  getConfigValue(key: string): any {
    return getDeepFromObject(this.options, key, null);
  }
}
